import Configuration from "../shared/configuration";
import EndPointEntity from "../shared/endpointentity";
import API from "../shared/API";
import Common from "./common";

// Combined Deliveries — orders currently held by the combined-delivery experiment: one or more
// splits are back in store but at least one sibling is still out, so the whole order is withheld
// from the Ready-for-Invoice list until every split returns. Reads the read-only
// Invoice_CombinedDeliveriesPending proc, which returns a JSON array. When the last sibling
// arrives the order drops off this list and appears on Ready-for-Delivery/Invoice automatically.
export default class CombinedDeliveriesService {
  constructor() {
    this.config = new Configuration();
    this.endpoint = new EndPointEntity();
    this.common = new Common();
  }

  async getPending(storeIDs, fromDate, toDate, isRetry) {
    const api = new API({ url: this.config.ITEM_STORE_URL });
    api.createEntity({ name: this.endpoint.COMBINED_DELIVERIES_PENDING });
    let out = {};
    await api.endpoints[this.endpoint.COMBINED_DELIVERIES_PENDING]
      .getAllPost({ StoreIDs: storeIDs, FromOrderDate: fromDate, ToOrderDate: toDate })
      .then((response) => { out = response.data; })
      .catch((err) => { out = this.common.handleError(err); });

    if (out && out.statusCode === 401 && !isRetry) {
      try {
        const response = await this.common.refreshToken();
        this.common.setToken(response);
        out = await this.getPending(storeIDs, fromDate, toDate, true);
        return out;
      } catch (e) {
        return { statusCode: 401, message: "Session expired - please log in again." };
      }
    }
    // WebAPI returns the list as a JSON string in Data; parse it here.
    if (out && typeof out.data === "string") {
      try { return JSON.parse(out.data); } catch (e) { return []; }
    }
    return Array.isArray(out && out.data) ? out.data : [];
  }
}
